import { render, staticRenderFns } from "./OffersParticipantGroupSubTable.vue?vue&type=template&id=611d5762"
import script from "./OffersParticipantGroupSubTable.vue?vue&type=script&lang=js"
export * from "./OffersParticipantGroupSubTable.vue?vue&type=script&lang=js"
import style0 from "./OffersParticipantGroupSubTable.vue?vue&type=style&index=0&id=611d5762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports